var ttsVoice = null;
var ttsInitVoiceListCount = 50;
var ttsInitVoiceListInterval = 500;
var ttsInitVoiceListIntervalHandle = false;

window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};
window.silesia.layout.marque = function(config) {

    return {
        init:function(){
            console.log('config',[config,this.$root,this.$el]);
            //Defered call
            if(!this.$root.dataset['loaded']) {
                this.$root.dataset['loaded'] = true;
                config = config||{};
                config.root = config.root||this.$root;
                config.root = ((typeof config.root==='string')&&document.querySelector(config.root)) ? document.querySelector(config.root) : this.$root;
                config.container = config.container||config.root.childNodes[0];
                config.container = ((typeof config.container==='string')&&config.root.querySelector(config.container)) ? config.root.querySelector(config.container) : config.root.childNodes[0];
                this.initMarque();                
            }
        },

        initMarque: function() {
            const scrollStep = 120;      // ile px przewija na kliknięcie
            const arrowZone = 50;       // szerokość obszaru kliknięcia po lewej/prawej stronie (px)
            const self = this;

            config.root.addEventListener("click", (e) => {
                const rect = config.root.getBoundingClientRect();
                const clickX = e.clientX - rect.left;

                // Kliknięcie w lewą "strefę"
                if (clickX < arrowZone) {
                    self.scrollBySafe(-scrollStep);
                }
                // Kliknięcie w prawą "strefę"
                else if (clickX > rect.width - arrowZone) {
                    self.scrollBySafe(scrollStep);
                }
            });
        },

        scrollBySafe:function(amount) {
            const maxScroll = config.container.scrollWidth - config.container.clientWidth;
            const current = config.container.scrollLeft;
            let target = current + amount;

            // Zabezpieczenie przed przekroczeniem granic
            if (target < 0) target = 0;
            if (target > maxScroll) target = maxScroll;

            config.container.scrollTo({
                left: target,
                behavior: "smooth"
            });
        }
    };
}




if(document.querySelector('*[x-data-lazy*="window.silesia.layout.marque"]')) {
    for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.marque"]')) {
        el.setAttribute('x-data', el.getAttribute('x-data-lazy'));
        //Fix - zmienne nie były widoczne w DOMie
        // el.setAttribute('x-init', 'load($el)');
        el.removeAttribute('x-data-lazy');

        //Fix - nie chciały się p[odpiać zdarzenia ox-n:click] jeśli stosujemy dynamiczne ładowanie
        // window.Alpine.initTree(el);
    };
}